import { creatorUseToggle } from '@derolfgroep/utils/lib/react/simpleStateManager/simpleStateManager'

const useToggleRightDrawer = creatorUseToggle()

export default useToggleRightDrawer
